import { Button, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import regex, { NOTIFIES } from '../../../constants/system.keys';
import { openMessage } from '../../../redux/actions';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 19 },
};

const ChangePasswordComponent = ({ namespace, data, onUpdate, onDone }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [requestId, setRequestId] = useState();
  const [addDataReturn, setAddDataReturn] = useState();
  const [, forceUpdate] = useState();
  const { updatePasswordMemberToNamespace } = useSelector((state) => state);

  const onFinish = (values) => {
    if (values.password !== values.confirm_password) {
      openMessage(
        NOTIFIES.WARNING,
        'New password and confirm password not match'
      );
      return;
    }

    let current = new Date().getTime();
    setRequestId(current);

    return onUpdate(current, {
      ...values,
      accountId: data?.accountId,
      namespace,
    });
  };

  useEffect(() => {
    if (
      updatePasswordMemberToNamespace &&
      updatePasswordMemberToNamespace.requestId === requestId
    ) {
      setAddDataReturn(updatePasswordMemberToNamespace);
    }
  }, [updatePasswordMemberToNamespace, requestId]);

  useEffect(() => {
    if (addDataReturn) {
      const { result, data, message } = addDataReturn;
      if (result === -3) {
        openMessage(NOTIFIES.WARNING, message);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        onDone(data);
      }
    }
  }, [addDataReturn, form, onDone]);

  useEffect(() => {
    forceUpdate({});
    return () => {
      form.resetFields();
    };
  }, [form]);

  return (
    <div className="add-whitelist-ip-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          name="password"
          label={t('New password')}
          rules={[
            {
              required: true,
              message: t('Please input new password!'),
            },
            {
              pattern: regex.isPassword,
              message: t(
                'Please input the valid characters: [a-zA-Z0-9/-+*?@#$%^&_.=:]'
              ),
            },
            {
              min: 3,
              message: t('Minimum 3 characters'),
            },
          ]}
        >
          <Input type="password" placeholder={t('New password')} />
        </Form.Item>
        <Form.Item
          name="confirm_password"
          label={t('Confirm password')}
          rules={[
            {
              required: true,
              message: t('Please input new password!'),
            },
            {
              pattern: regex.isPassword,
              message: t(
                'Please input the valid characters: [a-zA-Z0-9/-+*?@#$%^&_.=]'
              ),
            },
            {
              min: 3,
              message: t('Minimum 3 characters'),
            },
          ]}
        >
          <Input type="password" placeholder={t('Confirm password')} />
        </Form.Item>

        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button type="primary" htmlType="submit">
              {t('Update')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default ChangePasswordComponent;
